<style>

#app {}

</style>

<template>

<div id="app" :class="appClass">
    <div v-if="auth.recovering" class="jumbotron bg-transparent text-center margin-none">
        <h2>管理机连接中断，正在等待恢复...</h2>
        <p>服务恢复后会自动重新检查登录状态。</p>
    </div>

    <div v-else-if="!auth.ready" class="jumbotron bg-transparent text-center margin-none">
        <h2>正在检查登录状态...</h2>
    </div>

    <login-page v-else-if="!auth.authenticated" :initialized="auth.initialized" @authenticated="handleAuthenticated"></login-page>

    <template v-else>

        <navbar :store="store" :auth="auth" @logout="logout"></navbar>

        <sidebar :store="store"></sidebar>
        <div class="split-vertical">
            <div class="split-vertical-body">
                <div class="split-vertical-cell">
                    <div id="content">
                        <div class="container-fluid">
                            <router-view></router-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <foot></foot>

        <message :store="store"></message>

        <permission :store="store"></permission>

        <restart :store="store"></restart>
    </template>

</div>

</template>

<script>

import Navbar from './components/framework/Navbar.vue'
import Sidebar from './components/framework/Sidebar.vue'
import Foot from './components/framework/Footer.vue'
import Message from './components/widget/Message'
import Permission from './components/widget/Permission'
import Restart from './components/widget/Restart'
import LoginPage from './components/page/Login'
import miniToastr from 'mini-toastr'

export default {
    name: 'app',
    data() {
        return {
            ws: null,
            recoveryTimer: null,
            manualCloseSocket: false,
            auth: {
                ready: false,
                initialized: true,
                authenticated: false,
                username: '',
                loggingOut: false,
                recovering: false
            },
            store: {
                debug: true,
                state: {
                    message: false,
                    permission: false,
                    restart: false
                },
                showMessage() {
                    this.debug && console.log("报文显示")
                    this.state.message = true
                    this.state.permission = false
                    this.state.restart = false
                },
                hideMessage() {
                    this.debug && console.log("报文隐藏")
                    this.state.message = false
                    this.state.permission = false
                    this.state.restart = false
                },
                showPermission() {
                    this.debug && console.log("权限不足显示")
                    this.state.message = false
                    this.state.permission = true
                    this.state.restart = false
                },
                hidePermission() {
                    this.debug && console.log("权限不足隐藏")
                    this.state.message = false
                    this.state.permission = false
                    this.state.restart = false
                },
                showRestart() {
                    this.debug && console.log("重启显示")
                    this.state.message = false
                    this.state.permission = false
                    this.state.restart = true
                },
                hideRestart() {
                    this.debug && console.log("重启隐藏")
                    this.state.message = false
                    this.state.permission = false
                    this.state.restart = false
                }
            }
        }
    },
    computed: {
        appClass: function() {
            if (this.auth.authenticated) {
                return 'st-container show-sidebar sidebar-l2'
            }
            return ''
        }
    },
    methods: {
        loadAuthStatus: function() {
            this.$http.get('/auth/status').then(function(res) {
                var status = res.data.data || {}
                this.stopRecovery()
                this.auth.initialized = status.initialized
                this.auth.authenticated = status.authenticated
                this.auth.username = status.username || ''
                this.auth.recovering = false
                this.auth.ready = true
                if (this.auth.authenticated) {
                    this.initWebsocket()
                } else {
                    this.closeWebsocket()
                    this.$router.push('/')
                }
            }, function() {
                this.handleServiceUnavailable()
            })
        },
        handleAuthenticated: function() {
            this.loadAuthStatus()
        },
        logout: function() {
            this.auth.loggingOut = true
            this.stopRecovery()
            this.$http.post('/auth/logout').then(function() {
                this.closeWebsocket()
                this.auth.authenticated = false
                this.auth.username = ''
                this.auth.recovering = false
                this.auth.loggingOut = false
                this.$router.push('/')
            }, function() {
                this.auth.loggingOut = false
                alert("退出登录失败")
            })
        },
        handleServiceUnavailable: function() {
            if (this.auth.loggingOut) {
                return
            }
            this.closeWebsocket()
            this.auth.ready = false
            this.auth.recovering = true
            if (this.recoveryTimer) {
                return
            }
            this.recoveryTimer = setInterval(function() {
                this.loadAuthStatus()
            }.bind(this), 3000)
        },
        stopRecovery: function() {
            if (!this.recoveryTimer) {
                return
            }
            clearInterval(this.recoveryTimer)
            this.recoveryTimer = null
        },
        initWebsocket: function() {
            if (this.ws || !this.auth.authenticated) {
                return
            }
            this.manualCloseSocket = false
            var scheme = window.location.protocol === 'https:' ? 'wss' : 'ws'
            this.ws = new WebSocket(`${scheme}://${window.location.host}/ws`)
            this.ws.onmessage = this.websocketmessages
            this.ws.onclose = function() {
                this.ws = null
                if (this.manualCloseSocket) {
                    this.manualCloseSocket = false
                    return
                }
                if (this.auth.authenticated) {
                    this.handleServiceUnavailable()
                }
            }.bind(this)
        },
        closeWebsocket: function() {
            if (!this.ws) {
                return
            }
            this.manualCloseSocket = true
            this.ws.close()
            this.ws = null
        },
        websocketmessages: function(e) {
            console.log("this----", window.onload);
            var tar = JSON.parse(e.data)
            switch (tar.Cmd) {
                case 'message':
                    window.eventHub.$emit('onmessage', tar.Data)
                    break;
            }

        },
        send: function(e) {
            if (this.ws) {
                this.ws.send(e)
            }
        },
        toast: function(message) {
          switch (message.level) {
            case 'error':
              miniToastr.error(message.message)
              break;
              case 'success':
                miniToastr.success(message.message)
                break;
                case 'warn':
                  miniToastr.warn(message.message)
                  break;
            default:
              miniToastr.info(message.message)
          }
        }
    },
    created() {
        window.eventHub.$on('app', this.send)
        window.eventHub.$on('service-down', this.handleServiceUnavailable)
        miniToastr.init()
        window.eventHub.$on("toast", this.toast)
        this.loadAuthStatus()
    },
    beforeDestroy() {
        this.stopRecovery()
        this.closeWebsocket()
        window.eventHub.$off('app', this.send)
        window.eventHub.$off('service-down', this.handleServiceUnavailable)
        window.eventHub.$off("toast", this.toast)
    },
    components: {
        Navbar,
        Sidebar,
        Foot,
        Message,
        Permission,
        Restart,
        LoginPage
    }
}

</script>



// WEBPACK FOOTER //
// App.vue?6161046e